import React, { useState } from 'react';
import './Sidebar.css';

const AgentSidebar = ({ 
  activeView,
  onViewChange,
  user,
  onLogout,
  onBackToMain,
  isMobileOpen,
  onMobileClose,
  showKycOnboarding
}) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const menuItems = [
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: '📊',
      description: 'Business Overview',
      view: 'dashboard'
    },
    {
      id: 'purchase-cover',
      label: 'Purchase Cover',
      icon: '🛡️',
      description: 'Buy Insurance',
      view: 'purchase-cover'
    },
    {
      id: 'extend-policy',
      label: 'Buy/Extend Policy',
      icon: '🔁',
      description: 'Buy or extend policy',
      view: 'extend-policy'
    },
    {
      id: 'certificate-recovery',
      label: 'Check Certificate Status',
      icon: '🔧',
      description: 'Track and fix failed covers',
      view: 'certificate-recovery'
    },
    {
      id: 'comp-continuations',
      label: 'Extend Comprehensive',
      icon: '📋',
      description: 'COMP extensions due → requests@',
      view: 'comp-continuations'
    },
    {
      id: 'profile',
      label: 'Profile',
      icon: '👤',
      description: 'My Profile',
      view: 'profile'
    },
    {
      id: 'kyc-onboarding',
      label: 'IRA Licence',
      icon: '🔐',
      description: 'Upload your IRA licence',
      view: 'profile',
      selfRegisteredOnly: true
    },
    {
      id: 'employees',
      label: 'Employees',
      icon: '👥',
      description: 'Manage Employees',
      view: 'employees'
    },
    {
      id: 'generate-quote',
      label: 'Generate Quote',
      icon: '📋',
      description: 'Get a Quote',
      view: 'quote',
      action: () => window.open('http://quotations.monarchinsurance.co.ke/', '_blank')
    }
  ];

  const handleItemClick = (item) => {
    if (item.action) {
      item.action();
    } else if (item.view && onViewChange) {
      onViewChange(item.view);
    }
    if (onMobileClose) {
      onMobileClose();
    }
  };

  return (
    <aside className={`sidebar ${isCollapsed ? 'collapsed' : ''} ${isMobileOpen ? 'mobile-open' : ''}`}>
      <div className="sidebar-header">
        <div className="sidebar-logo">
          <div className="logo-icon">🛡️</div>
          {!isCollapsed && (
            <div className="logo-text">
              <h2>Agent Portal</h2>
              <span>Dashboard</span>
            </div>
          )}
        </div>
        
        <button 
          className="collapse-btn"
          onClick={() => setIsCollapsed(!isCollapsed)}
          title={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          aria-label={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        >
          {isCollapsed ? '▶' : '◀'}
        </button>
        
        {/* Mobile Close Button */}
        <button 
          className="mobile-close-btn"
          onClick={onMobileClose}
          title="Close menu"
          aria-label="Close menu"
        >
          ✕
        </button>
      </div>

      <nav className="sidebar-nav">
        <ul className="nav-list">
          {menuItems.filter((item) => !item.selfRegisteredOnly || showKycOnboarding).map((item) => (
            <li key={item.id} className="nav-item">
              <button
                className={`nav-link ${activeView === item.view ? 'active' : ''}`}
                onClick={() => handleItemClick(item)}
                title={isCollapsed ? item.label : ''}
              >
                <span className="nav-icon">{item.icon}</span>
                {!isCollapsed && (
                  <div className="nav-content">
                    <span className="nav-label">{item.label}</span>
                    <span className="nav-description">{item.description}</span>
                  </div>
                )}
                {activeView === item.view && (
                  <div className="active-indicator"></div>
                )}
              </button>
            </li>
          ))}
        </ul>
      </nav>

      <div className="sidebar-footer">
        <div className="user-section">
          <div className="user-avatar">
            {user?.username?.charAt(0).toUpperCase() || 'A'}
          </div>
          {!isCollapsed && (
            <div className="user-info">
              <span className="user-name">{user?.username || 'Agent'}</span>
              <span className="user-role">Agent</span>
            </div>
          )}
        </div>
        
        <div className="footer-actions">
          <button 
            className="back-to-main-btn"
            onClick={() => {
              if (onBackToMain) {
                onBackToMain();
              }
              if (onMobileClose) onMobileClose();
            }}
            title={isCollapsed ? 'Home (Dashboard)' : ''}
          >
            <span className="back-icon">🏠</span>
            {!isCollapsed && <span>Home (Dashboard)</span>}
          </button>
          <button 
            className="support-btn-footer"
            onClick={() => {
              window.open('https://wa.me/254738669931?text=hello', '_blank');
              if (onMobileClose) onMobileClose();
            }}
            title={isCollapsed ? 'Support' : ''}
          >
            <span className="support-icon">💬</span>
            {!isCollapsed && <span>Support</span>}
          </button>
          <button 
            className="logout-btn"
            onClick={() => {
              onLogout();
              if (onMobileClose) onMobileClose();
            }}
            title={isCollapsed ? 'Logout' : ''}
          >
            <span className="logout-icon">🚪</span>
            {!isCollapsed && <span>Logout</span>}
          </button>
        </div>
      </div>
    </aside>
  );
};

export default AgentSidebar;
